var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"svg-flag",attrs:{"src":require(`../../../assets/images/${_vm.lang}.svg`),"alt":_vm.lang}})
}
var staticRenderFns = []

export { render, staticRenderFns }